(function () {
    'use strict';

    angular.module('app.general', []);
})();